import React from 'react'

function ErrorPage() {
  return (
    <div>Sayfa Bulunamadı</div>
  )
}

export default ErrorPage